<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
<template>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>对话内容</span>
            <el-button class="copy-btn" style="float: right; padding: 3px 0" type="text"  >复制</el-button>
        </div>
        <div id="dialog-list">
            <div v-for="(item,index) in list" class="text item">
                <span>{{ item.Type == 0 ? '问：' : '答：' }}</span>{{ item.Content }}
            </div>
        </div>
    </el-card>
</template>

<script>
import { getUserWordBySessionID, BaseApiUrl } from "../api/api"
import ClipboardJS from 'clipboard'

export default {
    props: {},
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        sessionID:"",
        dialogTxt:"",
        list:[]
      };
    },
    methods: {
        getDialogList(){
            var that = this;
            getUserWordBySessionID(this.sessionID).then(res=>{
                console.log("dialog-result",res)
                if(res.data.success){
                    that.list = res.data.response
                     console.log(that.list)
                     for(var i = 0; i< that.list.length; i++){
                        var type = that.list[i].Type == 0 ? "问：" :"答：";
                        that.dialogTxt += type + that.list[i].Content +"   ";
                     }
                     console.log("dialogTxt",that.dialogTxt)
                }
            });
        },
        copyText(){  //复制
            var that = this
            const clipboard = new ClipboardJS(".copy-btn",{
                text(){
                    console.log("this.dialogTxt",this.dialogTxt)
                    return that.dialogTxt
                }
            });
        
            clipboard.on('success', e => {
                this.$message('复制成功');
                // 可以添加成功复制后的提示
                e.clearSelection(); // 清除选中的内容
            });
        
            clipboard.on('error', e => {
                console.log('复制失败！');
                this.$message('复制失败！');
                // 可以添加复制失败后的提示
            });
        }
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
        this.sessionID = this.$route.query.sessionID
        this.getDialogList();
        
        this.copyText()
    },
  };
</script>

<style>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width:100%;
  }
</style>
